import axios from "axios";
import { currentConfig } from "./config";

const api = axios.create({
  baseURL: currentConfig.baseURL,
  timeout: 50000,
});

export default api;